import React, { useState } from "react";

const faqData = {
  Warehousing: [
    { question: "Where are your warehouses located?", answer: "Our warehouses are strategically located near Mumbai Port, JNPT, and the international airport for seamless connectivity." },
    { question: "Do you provide inventory management?", answer: "Yes, we use advanced Warehouse Management Systems (WMS) to track stock levels and ensure accuracy." },
    { question: "Can you handle bonded warehousing?", answer: "Yes, we provide bonded warehousing facilities for goods awaiting customs clearance." },
    { question: "Do you offer temperature-controlled storage?", answer: "We have cold storage facilities for perishables, pharmaceuticals, and other sensitive goods." },
    { question: "Is 24/7 access available?", answer: "Authorized clients can access their inventory around the clock with secure entry systems." },
    { question: "Do you provide packaging services?", answer: "Yes, we offer professional packaging and labeling services to ensure goods are shipment-ready." },
    { question: "How do you ensure security?", answer: "Warehouses are equipped with CCTV, biometric access, and on-site security personnel." },
    { question: "Can you integrate with ERP systems?", answer: "Our WMS integrates seamlessly with major ERP platforms for real-time data synchronization." },
    { question: "Do you provide value-added services?", answer: "Yes, we offer kitting, assembly, and quality checks as part of our warehousing solutions." },
    { question: "What is your capacity?", answer: "We manage large-scale facilities with flexible space allocation to meet client requirements." }
  ],

  "Air Cargo": [
    { question: "Do you handle priority air freight?", answer: "Yes, we offer expedited air cargo services for time-sensitive shipments across domestic and international routes." },
    { question: "Can you handle temperature-controlled cargo?", answer: "Absolutely. We provide cold chain handling for pharmaceuticals, perishables, and temperature-sensitive goods." },
    { question: "Do you manage dangerous goods?", answer: "Yes, we comply with IATA regulations for handling hazardous materials safely." },
    { question: "What is your global coverage?", answer: "We partner with major airlines to provide worldwide reach." },
    { question: "Do you provide customs clearance with air cargo?", answer: "Yes, our air cargo service includes customs documentation and clearance." },
    { question: "Can you consolidate shipments?", answer: "We offer consolidation services to optimize costs and efficiency." },
    { question: "Do you provide door-to-door delivery?", answer: "Yes, we manage pickup, air freight, customs, and final delivery." },
    { question: "How do you track air shipments?", answer: "We provide real-time tracking and proactive updates." },
    { question: "Do you insure air cargo?", answer: "Yes, insurance options are available for all air shipments." },
    { question: "Can you handle oversized cargo?", answer: "We specialize in out-of-gauge and oversized cargo handling." }
  ],

  "Sea Cargo": [
    { question: "Do you support FCL and LCL shipments?", answer: "Yes, we manage both Full Container Load and Less than Container Load shipments with reliable ocean freight partners." },
    { question: "How do you manage port-to-door delivery?", answer: "Our end-to-end sea cargo service includes port handling, customs clearance, inland transport, and final delivery." },
    { question: "Do you provide reefer container services?", answer: "Yes, we offer refrigerated containers for perishable goods." },
    { question: "Can you handle bulk cargo?", answer: "We manage dry bulk and liquid bulk shipments efficiently." },
    { question: "Do you provide shipment consolidation?", answer: "Yes, we consolidate smaller shipments to reduce costs." },
    { question: "How do you ensure cargo safety?", answer: "We partner with trusted carriers and provide insurance options." },
    { question: "Do you offer charter services?", answer: "Yes, we arrange vessel charters for special requirements." },
    { question: "Can you manage hazardous cargo?", answer: "We comply with IMO regulations for dangerous goods." },
    { question: "Do you provide documentation support?", answer: "Yes, we handle bills of lading, certificates, and compliance paperwork." },
    { question: "What is your global reach?", answer: "We connect to major ports worldwide through reliable shipping lines." }
  ],

  "Customs Clearance": [
    { question: "Can you handle customs clearance for imports and exports?", answer: "Yes, we handle both import and export customs processes, including documentation, duties, and compliance checks." },
    { question: "Do you offer HS code classification support?", answer: "We provide HS code classification, tariff advice, and duty optimization to help customers avoid delays and fines." },
    { question: "Do you manage duty drawback claims?", answer: "Yes, we assist with duty drawback and refund claims." },
    { question: "Can you handle bonded shipments?", answer: "We manage bonded cargo through customs-approved facilities." },
    { question: "Do you provide compliance consulting?", answer: "Yes, we advise on trade regulations and compliance requirements." },
    { question: "Can you expedite clearance?", answer: "We leverage digital filing and trusted networks to speed up clearance." },
    { question: "Do you handle restricted goods?", answer: "Yes, we manage clearance for restricted and special-category goods." },
    { question: "Do you provide documentation services?", answer: "We prepare invoices, packing lists, and certificates of origin." },
    { question: "Can you integrate with logistics?", answer: "Yes, customs clearance is part of our end-to-end logistics solutions." },
    { question: "Do you offer post-clearance support?", answer: "We assist with audits, compliance checks, and dispute resolution." }
  ],

  Logistics: [
    { question: "Do you provide door-to-door logistics?", answer: "Yes, our multimodal logistics network delivers door-to-door solutions across road, rail, air, and sea." },
    { question: "How do you track shipments in transit?", answer: "We offer real-time tracking and proactive status updates for every stage of the shipment." },
    { question: "Do you provide multimodal transport?", answer: "Yes, we combine road, rail, air, and sea for optimal efficiency." },
    { question: "Can you handle last-mile delivery?", answer: "We specialize in last-mile delivery for e-commerce and retail." },
    { question: "Do you provide reverse logistics?", answer: "Yes, we manage returns and recycling logistics." },
    { question: "Do you offer supply chain consulting?", answer: "We provide optimization strategies for supply chain efficiency." },
    { question: "Can you integrate with ERP systems?", answer: "Our logistics platform integrates with ERP and WMS systems." },
    { question: "Do you provide fleet management?", answer: "Yes, we manage dedicated fleets for clients." },
    { question: "Do you handle oversized cargo?", answer: "We provide special equipment and permits for oversized loads." },
    { question: "Do you offer cross-border logistics?", answer: "Yes, we manage customs, compliance, and transport for international shipments." }
  ],

  Insurance: [
    { question: "Do you provide cargo insurance?", answer: "Absolutely. We offer marine, air, road, and rail cargo insurance with customizable coverage options." },
    { question: "What types of policies are available?", answer: "We provide both all-risk coverage and named perils policies tailored to shipment type and value." },
    { question: "Do you cover international shipments?", answer: "Yes, our insurance covers both domestic and international shipments." },
    { question: "Can you insure high-value goods?", answer: "We provide specialized coverage for luxury and high-value items." },
    { question: "Do you offer claim support?", answer: "Yes, we assist clients with claim filing and settlement." },
    { question: "Do you provide liability insurance?", answer: "We offer liability coverage for logistics and warehousing operations." },
    { question: "Can you customize policies?", answer: "Yes, policies are tailored to client needs and cargo type." },
    { question: "Do you cover natural disasters?", answer: "Our all-risk policies include coverage for natural calamities." },
    { question: "Do you provide short-term coverage?", answer: "Yes, we offer single-shipment and short-term policies." },
    { question: "Do you offer risk assessment?", answer: "We provide risk analysis and advisory before shipment." }
  ]
};


const Faq = () => {
  const [selectedCategory, setSelectedCategory] = useState("Warehousing");
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-content">
        <h2 className="section-title">Frequently Asked Questions</h2>

        {/* Category Selector */}
        <div className="faq-tabs">
          {Object.keys(faqData).map((category) => (
            <button
              key={category}
              onClick={() => {
                setSelectedCategory(category);
                setOpenIndex(null);
              }}
              className={selectedCategory === category ? "faq-tab active" : "faq-tab"}
            >
              {category}
            </button>
          ))}
        </div>

        {/* FAQ List */}
        <div className="faq-list">
          {faqData[selectedCategory].map((faq, index) => (
            <div
              key={index}
              className="faq-card"
              onClick={() => toggleFAQ(index)}
            >
              <h3 className="faq-question">{faq.question}</h3>
              {openIndex === index && (
                <p className="faq-answer">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;